export default __webpack_public_path__ + "static/media/FooterBackgroundTop.e24204d2.png";